export const GIFT_COMPLETE_PAGE_STATIC_KEY = 'giftCompletePage'
export default GIFT_COMPLETE_PAGE_STATIC_KEY
